/**
 * The top bar's "+ New site" link (owners and admins) deep-links to
 * `/sites#new`, and Sites & keys focuses its "New site" field. The router
 * does not track the hash, so a click while already on Sites & keys fires
 * `FOCUS_NEW_SITE_EVENT` instead of navigating.
 */
export const NEW_SITE_PATH = '/sites#new';
export const NEW_SITE_HASH = '#new';
export const FOCUS_NEW_SITE_EVENT = 'fx-focus-new-site';

export function requestNewSiteFocus(): void {
  window.history.replaceState(null, '', NEW_SITE_PATH);
  window.dispatchEvent(new Event(FOCUS_NEW_SITE_EVENT));
}
